import { type InsuranceCorporateIdentity } from "../types";

export function BKKFirmusLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M244.938 450C192.442 450 139.946 430.091 100 390.355L110.581 379.829C184.65 453.509 305.226 453.509 379.377 379.829C415.303 344.091 435.072 296.603 435.072 246.177C435.072 195.752 415.303 148.182 379.377 112.526L389.958 102C428.674 140.513 450 191.754 450 246.177C450 300.601 428.674 351.842 389.958 390.355C349.848 430.091 297.352 450 244.938 450Z"
        fill="white"
      />
      <path
        d="M364.076 202.922C364.076 200.159 363.831 197.396 363.667 194.715C370.451 210.316 374.211 227.461 374.211 245.581C374.211 316.762 316.18 374.454 244.582 374.454C225.047 374.454 206.576 370.066 189.984 362.347C194.316 362.672 198.648 362.997 203.061 362.997C291.987 362.916 364.076 291.247 364.076 202.922ZM402 245.5C402 159.043 331.464 89 244.5 89C157.536 89 87 159.124 87 245.5C87 331.876 157.536 402 244.5 402C331.464 402.081 402 331.957 402 245.5Z"
        fill="white"
      />
    </svg>
  );
}

export const BKKFirmus: InsuranceCorporateIdentity = {
  id: "bkk-firmus",
  name: "BKK firmus",
  logo: BKKFirmusLogo,
  backgroundColor: "#F39400",
  textColor: "#FFFFFF",
  wildcard: "bkk firmus",
  type: "statutory",
};
